// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as EstimateLayoutModuleScss from "../styles/EstimateLayout.module.scss";

var styles = EstimateLayoutModuleScss;

function EstimateLayout(Props) {
  var title = Props.title;
  var sub_title = Props.sub_title;
  var title_mobile = Props.title_mobile;
  var sub_title_mobile = Props.sub_title_mobile;
  var children = Props.children;
  var close_modal = Props.close_modal;
  var classNameOpt = Props.className;
  var close_icon = Props.close_icon;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("div", {
              className: "" + styles["estimate-layout-container"] + " " + className + ""
            }, React.createElement("section", {
                  className: styles["title-container"]
                }, React.createElement("p", {
                      className: styles.title
                    }, title), React.createElement("p", {
                      className: styles["sub-title"]
                    }, sub_title), React.createElement("p", {
                      className: styles["title-mobile"]
                    }, title_mobile), sub_title_mobile !== undefined ? React.createElement("p", {
                        className: styles["sub-title-mobile"]
                      }, sub_title_mobile) : null), React.createElement("section", {
                  className: styles["form-container"]
                }, children), React.createElement("button", {
                  className: styles["close-modal-button"],
                  onClick: (function (param) {
                      Curry._1(close_modal, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: close_icon.path,
                      height: 24.0,
                      width: 24.0,
                      quality: 100.0,
                      alt: close_icon.alt_text
                    })));
}

var make = EstimateLayout;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
